import $ from 'jquery';
import { debounce } from './../../utils';
$(function () {
  var $transcriptClose = $('.video-transcript__control--close');
  var $transcriptOpen = $('.video-transcript__control--open');
  var $videoPlayers = $('.video-player');
  var windowWidth = window.innerWidth;
  $videoPlayers.each(resizeVideoPlayer);
  $transcriptClose.on('click touch', toggleTranscriptOff);
  $transcriptOpen.on('click touch', toggleTranscriptOn);
  $(window).on('resize', debounce(onResize, 20));

  ////

  function onResize() {
    if (windowWidth === window.innerWidth) {
      return;
    } else {
      windowWidth = window.innerWidth;
    }
    $videoPlayers.each(resizeVideoPlayer);
  }
  function resizeVideoPlayer(index, videoPlayer) {
    var $videoPlayer = $(videoPlayer);
    var width = $videoPlayer.width();
    var height = width * (9 / 16);
    $videoPlayer.css({
      height: height + 'px'
    });
  }
  function toggleTranscript($toggle, isActive) {
    var $transcript = $toggle.closest('.video-transcript');
    var method = isActive ? 'addClass' : 'removeClass';
    $transcript[method]('active');
  }
  function toggleTranscriptOff(event) {
    event.preventDefault();
    event.stopPropagation();
    toggleTranscript($(this), false);
  }
  function toggleTranscriptOn(event) {
    event.preventDefault();
    event.stopPropagation();
    toggleTranscript($(this), true);
  }
});